module.exports = __webpack_public_path__ + "assets/img/uesrIcon1.0dc7e046.png";